import axios from "axios";
import {
  INSTANCE_URL,
  LOGIN,
  REGISTER,
  FETCH_SPEAKERS,
  SELECT_FEATURE,
} from "Constants";
import { STEP_CREATE, STEP_VERIFY, STEP_CHOOSE, STEP_FINISH } from "Signup";
import { SIGNUP_STEP, SIGNUP_FEATURE_SELECT } from "SignupReducer";
import { EVENT } from "Actions";

import { getHeaders } from "CommonUtils";

export function createEvent(eventName, appTabs, user, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event`;
  var payload = {
    resource: [
      {
        eventname: eventName,
        navigationtextcolor: "",
        onesignalid: "",
        onesignalkey: "",
      },
    ],
    scheduledates: [],
    apptabs: appTabs,
    userid: user.adminuserid,
  };

  var response = axios.post(url, payload, getHeaders(session));
  return (dispatch) => {
    response
      .then(({ data }) => {
        // fetch event id and store it to redux
        dispatch({
          type: EVENT,
          payload: {
            eventname: eventName,
            eventid: data.resource[0].eventid,
          },
        });

        // proceed to the step finish
        dispatch({ type: SIGNUP_STEP, payload: STEP_FINISH });
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}
